import { render, staticRenderFns } from "./ClientPicker.vue?vue&type=template&id=d7803710&scoped=true&"
import script from "./ClientPicker.vue?vue&type=script&lang=js&"
export * from "./ClientPicker.vue?vue&type=script&lang=js&"
import style0 from "./ClientPicker.vue?vue&type=style&index=0&id=d7803710&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7803710",
  null
  
)

export default component.exports